<template>
  <main-content with_go_back_bar>
    <kt-panel>
      <form
        @submit.prevent="submitRequest($event, query)"
        id="single-request-form"
        class="kt-form p-3 my-4"
      >
        <div
          class="container p-3 pt-5 my-4 border in-border-header"
          style="padding-top: 1.5rem !important"
        >
          <kt-form-section is_first>
            <div class="section-header">
              {{ "جزئیات فاکتور" }}
            </div>
            <kt-row class="p-2">
              <div class="w-100 d-flex justify-content-between mx-2">
                <div>
                  <h5>تاریخ صدور فاکتور</h5>
                  <p class="font-weight-normal">
                    {{ detailFactor.scheduler_start_date }}
                  </p>
                </div>
                <div class="ml-5">
                  <h5>شماره فاکتور</h5>
                  <p class="font-weight-normal" v-if="detailFactor.code !== null">
                    {{ detailFactor.code }}
                  </p>
                  <p class="font-weight-normal" v-else>______</p>
                </div>
              </div>
              <!-- Details Factor -->
              <div class="col-md-12">
                <h4 class="text-center text-dark font-weight-bold">
                  {{ detailFactor.title }}
                </h4>
              </div>
              <!--Format-->
              <div v-if="detailFactor.format" class="mb-5 mt-3 mx-4 w-100">
                <!--String-->
                <div  class="mb-3 d-flex flex-wrap">
                  <StringInput
                      v-if="string_fields.length > 0"
                      v-for="field in string_fields"
                      :key="field.id"
                      :field="field"
                  />
                  <NumericInput
                      v-if="numeric_fields.length > 0"
                      v-for="field in numeric_fields"
                      :key="field.id"
                      :field="field"
                  />
                  <DateInput
                      v-if="date_fields.length > 0"
                      v-for="field in date_fields"
                      :key="field.id"
                      :field="field"
                  />
                  <SelectInput
                      v-if="select_fields.length > 0"
                      v-for="field in select_fields"
                      :key="field.id"
                      :field="field"
                  />
                  <TextInput
                      v-if="text_fields.length > 0"
                      v-for="field in text_fields"
                      :key="field.id"
                      :field="field"
                  />
                </div>
              </div>
              <!--Customer-->
              <div v-if="detailFactor.customer" class="col-md-6 my-5 factorPersonalInfo">
                <h5>مشخصات مشتری</h5>
                <p class="text-dark font-weight-normal">
                  {{ detailFactor.customer ? detailFactor.customer.name : '-'}}
                </p>
                <p dir="ltr" class="text-dark font-weight-normal">
                  {{ detailFactor.customer ? detailFactor.customer.mobile : '-' }}
                </p>
              </div>
              <div class="my-5"></div>
              <div class="row my-5 mx-3">
                <table class="table">
                  <thead class="thead-light text-center">
                    <tr>
                      <th>آیتم</th>
                      <th>تعداد</th>
                      <th>مبلغ واحد</th>
                      <th>مبلغ کل</th>
                      <th>مجموع</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in detailFactor.items" :key="(item, idx)">
                      <td>{{ item.title }}</td>
                      <td>{{ item.number }}</td>
                      <td>{{ Number(item.unit_amount).toLocaleString() + " ریال" }}</td>
                      <td>{{ Number(item.total_amount).toLocaleString() + " ریال" }}</td>
                      <td>{{ Number(item.final_amount).toLocaleString() + " ریال" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-6">
                <div class="bg-light p-4 my-2">
                  <span>پیغام : </span>
                  <span>{{ detailFactor.message }}</span>
                </div>
                <div class="bg-light p-4 my-4">
                  <span>قوانین : </span>
                  <span>{{ detailFactor.rules }}</span>
                </div>
              </div>
              <div class="col-md-6 mt-4">
                <div class="d-flex align-items-start justify-content-between">
                  <h5>مبلغ کل</h5>
                  <p class="font-weight-normal">
                    {{ Number(detailFactor.factor_amount).toLocaleString() + " ریال" }}
                  </p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5>هزینه حمل و نقل</h5>
                  <p class="font-weight-normal">
                    {{ Number(detailFactor.shipping_cost).toLocaleString() + " ریال" }}
                  </p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5>مجموع تخفیف</h5>
                  <p class="font-weight-normal">
                    {{
                      Number(detailFactor.factor_discount_amount).toLocaleString() +
                      " ریال"
                    }}
                  </p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5 class="font-weight-bold"> مبلغ قابل پرداخت (با احتساب مالیات)</h5>
                  <p class="text-primary font-weight-bold">
                    {{
                      Number(detailFactor.factor_final_amount).toLocaleString() + " ریال"
                    }}
                  </p>
                </div>
              </div>
              <div
                style="border-bottom: 1px solid #eee; padding: 1rem"
                class="col-md-12 mb-5"
              ></div>
              <!-- TimeLine and Visited -->
              <div class="col-md-12">
                <div class="text-center text-dark my-4">
                  <h1
                    v-if="detailFactor.is_archived"
                    class="alert alert-danger d-block col-md-4 mx-auto p-3"
                  >
                    <span class="text-white">فاکتور آرشیو است</span>
                  </h1>
                  <h1
                    v-if="detailFactor.status === 0"
                    class="alert alert-danger d-block col-md-4 mx-auto p-3"
                  >
                    <span class="text-white">فاکتور معلق است</span>
                  </h1>
                </div>
              </div>
              <div class="col-md-12">
                <div class="accordion" id="accordionExample">
                  <div class="card">
                    <div class="card-header" id="headingOne">
                      <h2 class="mb-0">
                        <button
                          class="btn btn-block text-left text-dark"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          تاریخ
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between">
                          <p class="text-primary">تاریخ اولین ارسال</p>
                          <p v-if="['1' , '3'].includes(detailFactor.type)">
                            {{ detailFactor.simple_sent_date }}
                          </p>
                          <p v-if="detailFactor.type === '2'">
                            {{ detailFactor.scheduler_start_date }}
                          </p>
                        </div>
                        <div class="d-flex align-items-center justify-content-between">
                          <p class="text-primary">سر رسید</p>
                          <p v-if="['1', '3'].includes(detailFactor.type)">
                            {{ detailFactor.simple_due_date }}
                          </p>
                          <p v-if="detailFactor.type === '2'">
                            {{ "بعد از " + detailFactor.scheduler_due_days + " روز" }}
                          </p>
                        </div>
                        <div
                            class="w-100 d-flex flex-row align-items-center justify-content-between"
                        >
                          <h6
                              v-if="      detailFactor.type === '3' &&
                                detailFactor.is_archived === false &&
                                detailFactor.status === 1
                              "
                              class="btn btn-primary text-center"
                          >
                            <router-link :to="`/invoice/${detailFactor.id}/sub-factor`" class="router-link-white text-white"
                            > لینک پرداخت فاکتور اصلی
                            </router-link>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card dark-theme-bg-dark" v-if="detailFactor.type === '3' && detailFactor.sub_factors.length > 0">
                    <div v-for="sub in detailFactor.sub_factors" :key="sub.id">
                      <div class="card-header" id="headingTwo">
                        <h2 class="mb-0">
                          <button
                              class="btn btn-block collapsed text-left text-dark d-flex flex-row align-item-center justify-content-between"
                              type="button"
                              data-toggle="collapse"
                              :data-target="`#collapse-${sub.id}`"
                              aria-expanded="false"
                              :aria-controls="`collapse-${sub.id}`"
                          >
                            <div
                                class="d-flex flex-row align-items-center justify-content-center"
                            >
                              <h6 class="mr-4 router-link-white">فاکتور تاریخ {{ sub.sending_date }}</h6>
                              <h6
                                  v-if="
                                  detailFactor.is_archived === false &&
                                  detailFactor.status === 1
                                "
                                  class="btn btn-primary text-center mx-5"
                              >
                                <router-link :to="`/invoice/${detailFactor.id}/sub-factor/${sub.id}`" class="router-link-white text-white"
                                >لینک پرداخت
                                </router-link>
                              </h6>
                              <h6
                                  class="badge badge-danger"
                                  v-if="sub.cancelled_at !== null"
                              >
                                فاکتور لغو شد
                              </h6>
                              <h6 class="badge badge-success" v-if="sub.paid_at">
                                پرداخت شده
                              </h6>
                            </div>
                            <div>
                              <i class="fa fa-angle-down router-link-white"></i>
                            </div>
                          </button>
                        </h2>
                      </div>
                      <div
                          class="collapse"
                          :id="`collapse-${sub.id}`"
                          aria-labelledby="headingTwo"
                          data-parent="#accordionExample"
                      >
                        <div class="card-body">
                          <div class="container">
                            <div class="wrapper">
                              <div
                                  class="lineView d-flex align-items-center justify-content-between"
                              >
                                <div class="mb-5">
                                  <button
                                      class="btn btn-primary ml-3"
                                      type="button"
                                      @click="reminder(sub.id)"
                                      :disabled="detailFactor.is_archived === true || detailFactor.status === 0 || sub.cancelled_at !== null"
                                  >
                                    یادآوری فاکتور
                                  </button>
                                  <button
                                      class="btn btn-danger"
                                      type="button"
                                      @click="cancel(sub.id)"
                                      v-if="sub.cancelled_at === null"
                                      :disabled="detailFactor.is_archived === true || detailFactor.status === 0"
                                  >
                                    لغو فاکتور
                                  </button>
                                </div>
                                <div>
                                  <ul
                                      class="font-weight-bold mt-4"
                                      v-if="sub.cancelled_at !== null"
                                  >
                                    <div class="timeShow">
                                      <div class="time w-100">
                                        {{ sub.cancelled_at }}
                                      </div>
                                      <p class="text-timeShow mx-3">فاکتور لغو شد</p>
                                    </div>
                                  </ul>
                                  <ul
                                      class="font-weight-bold mt-4 sessions"
                                      v-if="sub.reminder_at !== null"
                                  >
                                    <div class="timeShow">
                                      <div class="time w-100">
                                        {{ sub.reminder_at }}
                                        <p class="text-timeShow">فاکتور یادآوری شد</p>
                                      </div>
                                    </div>
                                  </ul>
                                </div>
                              </div>
                              <div v-if="sub.fields">
                                <div v-for="(index,field) in sub.fields" :key="index">
                                  <label class="text-dark" :id="field.id" :for="field.id">
                                    {{ field }}: {{ index || '-' }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="detailFactor.type !== '3'" class="card" v-for="sub in detailFactor.sub_factors" :key="sub.id">
                    <div class="card-header" id="headingTwo">
                      <h2 class="mb-0">
                        <button
                          class="btn btn-block collapsed text-left text-dark d-flex flex-row align-item-center justify-content-between"
                          type="button"
                          data-toggle="collapse"
                          :data-target="`#collapse-${sub.id}`"
                          aria-expanded="false"
                          :aria-controls="`collapse-${sub.id}`"
                        >
                          <div
                            class="d-flex flex-row align-items-center justify-content-center"
                          >
                            <h6 class="mr-4">فاکتور تاریخ {{ sub.sending_date }}</h6>
                            <h6
                              v-if="
                                sub.cancelled_at === null &&
                                detailFactor.is_archived === false &&
                                detailFactor.status === 1
                              "
                            >
                              <router-link :to="`/invoice/${sub.id}`"
                                >لینک پرداخت</router-link
                              >
                            </h6>
                            <h6
                              class="badge badge-danger"
                              v-if="sub.cancelled_at !== null"
                            >
                              فاکتور لغو شد
                            </h6>
                            <h6 class="badge badge-success" v-if="sub.paid_at">
                              پرداخت شده
                            </h6>
                          </div>
                          <div>
                            <i class="fa fa-angle-down"></i>
                          </div>
                        </button>
                      </h2>
                    </div>
                    <div
                      class="collapse"
                      :id="`collapse-${sub.id}`"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="container">
                          <div class="wrapper">
                            <div
                              class="lineView d-flex align-items-center justify-content-between"
                            >
                              <div class="mb-5">
                                <button
                                  class="btn btn-primary mr-3"
                                  type="button"
                                  @click="reminder(sub.id)"
                                  :disabled="detailFactor.is_archived === true || detailFactor.status === 0 || sub.cancelled_at !== null"
                                >
                                  یادآوری فاکتور
                                </button>
                                <button
                                  class="btn btn-danger"
                                  type="button"
                                  @click="cancel(sub.id)"
                                  v-if="sub.cancelled_at === null"
                                  :disabled="detailFactor.is_archived === true || detailFactor.status === 0"
                                >
                                  لغو فاکتور
                                </button>
                              </div>
                              <div>
                                <qrcode-vue
                                  :value="`${sub.url}`"
                                  :size="size"
                                  level="M"
                                />
                              </div>
                            </div>
                            <div>
                              <ul
                                class="font-weight-bold mt-4"
                                v-if="sub.cancelled_at !== null"
                              >
                                <div class="timeShow">
                                  <div class="time w-100">
                                    {{ sub.cancelled_at }}
                                  </div>
                                  <p class="text-timeShow">فاکتور لغو شد</p>
                                </div>
                              </ul>
                              <ul
                                class="font-weight-bold mt-4 sessions"
                                v-if="sub.reminder_at !== null"
                              >
                                <div class="timeShow">
                                  <div class="time w-100">
                                    {{ sub.reminder_at }}
                                    <p class="text-timeShow">فاکتور یادآوری شد</p>
                                  </div>
                                </div>
                              </ul>
                            </div>
                            <ul class="sessions">
                              <li
                                v-for="(timeSub, idx) in sub.visited_at"
                                :key="(timeSub, idx)"
                              >
                                <div class="time w-100">{{ timeSub }}</div>
                                <p>فاکتور مشاهد شد</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </kt-row>
          </kt-form-section>
        </div>
      </form>
    </kt-panel>
  </main-content>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import {StarShopApiUrl} from "@/common/api.service";
import toastr from "toastr";
import { KTApp } from "@/plugins/core/app";
import { mapGetters } from "vuex";
import mainContent from "@/components/main-content";
import QrcodeVue from "qrcode.vue";
import { onlineFactorService } from "@/common/api.service";
import StringInput from "@/views/online-factor/components/StringInput.vue";
import NumericInput from "@/views/online-factor/components/NumericInput.vue";
import DateInput from "@/views/online-factor/components/DateInput.vue";
import SelectInput from "@/views/online-factor/components/SelectInput.vue";
import TextInput from "@/views/online-factor/components/TextInput.vue";
import {fieldTypesConstants} from "@/constants/CustomerFormatFieldTypes";

export default {
  components: {
    TextInput,
    SelectInput,
    DateInput,
    NumericInput,
    StringInput,
    "main-content": mainContent,
    QrcodeVue,
  },
  props: {
    submitSingleRequest: {
      default: function ($event, query) {},
      type: Function,
    },
  },
  data() {
    return {
      query: {
        is_unlimited: false,
      },
      hashid: this.$route.params.hashid,
      editable: true,
      size: 100,
      message: "Copy These Text",
    };
  },
  computed: {
    ...mapGetters("onlineFactor", ["detailFactor"]),
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };
      return toastr;
    },
    fieldTypes() {
      return fieldTypesConstants
    },
    string_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type === this.fieldTypes.STRING)
      }
    },
    numeric_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type === this.fieldTypes.NUMERIC)
      }
    },
    text_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type === this.fieldTypes.TEXT)
      }
    },
    date_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type === this.fieldTypes.DATE)
      }
    },
    select_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type === this.fieldTypes.SELECT)
      }
    }
  },
  methods: {
    submit(e, query) {
      let form = $("#single-request-form");
      let btn = $("#form-btn");

      form.validate({
        rules: {
          customer_type: {
            required: true,
          },
          real_first_name: {
            required: true,
          },
          real_last_name: {
            required: true,
          },
          mobile: {
            required: true,
          },
          email: {
            required: true,
          },
        },
      });

      if (!form.valid()) return;

      KTApp.progress(btn);

      axios({
        url: StarShopApiUrl.path(`factor/${this.hashid}`),
        method: "POST",
        params: {
          customer_type: this.detailCustomer.customer_type,
          real_first_name: this.detailCustomer.real_first_name,
          real_last_name: this.detailCustomer.real_last_name,
          email: this.detailCustomer.email,
          mobile: this.detailCustomer.mobile,
          // image: this.file
        },
      })
        .then((response) => {
          this.toastr.success(response.data.message);
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
        })
        .finally((response) => {
          KTApp.unprogress(btn);
        });
    },
    currencyFormat(price) {
      price = Math.floor(price / 10);
      const pieces = parseFloat(price).toFixed(0).split("");
      let ii = pieces.length;

      while ((ii -= 3) > 0) {
        pieces.splice(ii, 0, ",");
      }

      return pieces.join("");
    },
    processFile(e) {
      let file = event.target.files[0];
      let output = document.getElementById("logo_preview");
      output.src = URL.createObjectURL(event.target.files[0]);
      output.onload = function () {
        URL.revokeObjectURL(output.src); // free memory
      };
    },
    doCopy() {
      this.$copyText(this.value).then((e) => {
        this.toastr.success("کپی شد");
        console.log(e);
      });
    },
    reminder(id) {
      onlineFactorService
        .remindFactor(id)
        .then((response) => {
          this.toastr.success(response.data.message);
          this.$router.go(this.$router.currentRoute);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancel(id) {
      onlineFactorService
        .cancelFactor(id)
        .then((response) => {
          this.toastr.success(response.data.message);
          this.$router.go(this.$router.currentRoute);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    printPage() {
      window.print();
    },
  },
  mounted() {
    let is_admin = this.$can('read', 'payment-link');
    let action = is_admin ? 'onlineFactor/adminShowFactor' : 'onlineFactor/showFactor';
    this.$store.dispatch(action, this.$route.params.hashid);
  },
};
</script>
<style scoped>
.preview_img {
  max-width: 70px;
  max-height: 70px;
  position: absolute;
  top: 10px;
  left: 80px;
}

.c_pointer {
  cursor: pointer;
}

ul,
li {
  list-style: none;
  padding: 0;
}

.containers {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  background: linear-gradient(45deg, #209cff, #68e0cf);
  padding: 3rem 0;
}
.wrapper {
  background: #eaf6ff;
  padding: 2rem;
  border-radius: 15px;
}
h1 {
  font-size: 1.1rem;
  font-family: sans-serif;
}
.sessions {
  margin-top: 2rem;
  border-radius: 12px;
  position: relative;
}
li {
  padding-bottom: 1.5rem;
  border-right: 1px solid #abaaed;
  position: relative;
  padding-right: 20px;
  margin-right: 10px;
  /* margin-top: -1.5rem; */
}
li:first-child {
  padding-bottom: 1.5rem;
  border-right: 1px solid #abaaed;
  position: relative;
  padding-right: 20px;
  margin-right: 10px;
  margin-top: -2rem;
}

.timeShow {
  padding-bottom: 1.5rem;
  border-right: 1px solid #abaaed;
  position: relative;
  padding-right: 20px;
  margin-right: 10px;
  margin-bottom: -1.5rem;
}

.timeShow::after {
  content: "";
  width: 15px;
  height: 15px;
  background: white;
  border: 1px solid #4e5ed3;
  box-shadow: 3px 3px 0px #bab5f8;
  box-shadow: 3px 3px 0px #bab5f8;
  border-radius: 50%;
  position: absolute;
  right: -8px;
  top: 0px;
}

.text-timeShow {
  font-size: 12px;
  font-weight: 400;
}

li:last-child {
  border: 0px;
  padding-bottom: 0;
}

li::after {
  content: "";
  width: 15px;
  height: 15px;
  background: white;
  border: 1px solid #4e5ed3;
  box-shadow: 3px 3px 0px #bab5f8;
  box-shadow: 3px 3px 0px #bab5f8;
  border-radius: 50%;
  position: absolute;
  right: -8px;
  top: 0px;
}

.time {
  color: #2a2839;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
p {
  color: #4f4f4f;
  font-family: sans-serif;
  line-height: 1.5;
  margin-top: 0.4rem;
}

@media screen and (max-width: 1000px) {
  .marginTopSm {
    margin: 1rem 0 0 0;
  }
  .factorPersonalInfo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  tr td {
    font-size: 10px;
  }

  table thead {
    font-size: 9px;
  }
}
</style>
